    
    
    @if (recommendation) {
    <div>
        <div>
            <span [innerHTML]="recommendation.recommendedText | translate"></span>
        </div>
        <div class="d-flex program-grid pt-4">
            <div class="program-row">
                <div class="card">
                    <div class="card-header d-flex">
                        <img class="global-entry" src="{{recommendation.card.imageSrc}}" alt="{{recommendation.card.imageAlt | translate}}">
                        <div class="program-price-container ms-auto">
                            <h3 class="program-price program-price-air"><b>${{recommendation.card.headerPrice.cost}}</b></h3>
                            <span style="display: block;" *ngFor="let costInfo of recommendation.card.headerPrice.costInfo; let i = index">{{ costInfo | translate}}</span>
                        </div>
                    </div>
        
                    <div class="card-body d-flex flex-column">
                    <p class="h3" [innerHTML]="recommendation.card.title | translate"></p>
        
                    <div *ngFor="let desciption of recommendation.card.description; let i = index">
                        <p [innerHTML]="desciption | translate"></p>
                    </div>
                    @if (recommendation.card.includesPreCheck === 'yes')  {
                        <p><i><span [innerHTML]="'IMAGE_ALT.DOESINCLUDE_TSA_PRECHECK' | translate"></span></i></p>
                    }
                    @else if (recommendation.card.includesPreCheck === 'maybe')  {
                        <p><i>{{'PROGRAM_SELECTION.SELECT_A_PROGRAM.MAY_INCLUDE'| translate}} <span [innerHTML]="'DASHBOARD.TSA_PRECHECK' | translate"></span></i></p>
                    }

                    <div class="mt-auto">
                        @if (recommendation.code === 'TSA') {
                            <a class="btn btn-primary tsa-btn" tabindex="0" [attr.href]="TSA_LOGIN_URL"
                            (click)="logGetStartedProgram('TSA'); closeModal();" (keyup.enter)="logGetStartedProgram('TSA'); closeModal();" target="_blank"
                            rel="noopener noreferrer"><span>{{'HOME.APPLY_NOW' | translate}}<i class="uswds-icon icon-launch"></i></span></a>
                        }
                        @else if (recommendation.code === 'UP') {
                            <a class="btn btn-primary" tabindex="0" (click)="showConsiderTSAModal();" (keyup.enter)="showConsiderTSAModal();"
                                target="_blank" rel="noopener noreferrer" data-bs-dismiss="modal">{{'HOME.APPLY_NOW' | translate}}</a>
                            <a class="learn-more ps-2" href="#" data-bs-dismiss="modal" [routerLink]="['programs-info']" [queryParams]="{code: recommendation.code}" translate>HOME.ABOUT.LEARN_MORE</a>
                        }
                        @else {
                            <a class="btn btn-primary" tabindex="0" (click)="logIn(recommendation.code);" (keyup.enter)="logIn(recommendation.code);"
                                target="_blank" rel="noopener noreferrer" data-bs-dismiss="modal">{{'HOME.APPLY_NOW' | translate}}</a>
                            <a class="learn-more ps-2" href="#" data-bs-dismiss="modal" [routerLink]="['programs-info']" [queryParams]="{code: recommendation.code}" translate>HOME.ABOUT.LEARN_MORE</a>
                        }
                    </div>
                    </div>
                </div>
            </div>
    
        </div>
        
        @if (recommendation.note) {
            <div class="pt-4">
                <h3 class="fw-bold">{{recommendation.noteHeader | translate}}</h3>
                <p [innerHTML] = "recommendation.note | translate"></p>
            </div>
        }
    
        <div class="pt-5">
            <h3 class="fw-bold">{{'MODAL.BENEFITS' | translate}}</h3>
    
            <div class="d-flex pt-5 gap-3 justify-content-center">
                <div class="benefit-container d-flex flex-column" *ngFor="let benefit of recommendation.benefits; let i = index">
                    <span class="benefit-icon" [innerHTML]="benefit.icon"></span>
                    <span [innerHTML]="benefit.description | translate"></span>
                </div>
            </div>
        </div>
    
        <div class="pt-4">
            @if (recommendation.code === 'TSA') {        
                <div class="w-100 text-center pt-3">
                    <a class="btn btn-primary tsa-btn" tabindex="0" [attr.href]="TSA_LOGIN_URL"
                        (click)="logGetStartedProgram('TSA'); closeModal();" (keyup.enter)="logGetStartedProgram('TSA'); closeModal();" target="_blank"
                        rel="noopener noreferrer"><span>{{'HOME.APPLY_NOW' | translate}}<i class="uswds-icon icon-launch"></i></span></a>
                </div>

            }
            @else {
                <div class="w-100 text-center">
                    <a href="" class="learn-more ms-auto" (click)="closeModal()" (keyup.enter)="closeModal()" 
                        [routerLink]="['programs-info']" [queryParams]="{code: recommendation.code}" [translateParams]="{value: recommendation.programName }" translate>HOME.COMPARISON_STEPPER.LEARN_MORE_ABOUT</a>
                </div>
        
                @if (recommendation.code === 'UP') {
                    <div class="w-100 text-center pt-3">
                        <a class="btn btn-primary ms-auto" tabindex="0" (click)="showConsiderTSAModal();" (keyup.enter)="showConsiderTSAModal();"
                        target="_blank" rel="noopener noreferrer">{{'HOME.APPLY_NOW' | translate}}</a>
                    </div>
                } 
                @else {
                    <div class="w-100 text-center pt-3">
                        <a class="btn btn-primary ms-auto" tabindex="0" (click)="logIn(recommendation.code);" (keyup.enter)="logIn(recommendation.code);"
                        target="_blank" rel="noopener noreferrer">{{'HOME.APPLY_NOW' | translate}}</a>
                    </div>
                }
            }
        </div>
    </div>
    }
    @else {
        <div>
            <h3>{{'HOME.COMPARISON_STEPPER.NO_BEST_MATCH' | translate}}</h3>
        </div>
    }

    <div *ngIf="otherOptions.length > 0" class="pt-5">

        <div>{{'HOME.COMPARISON_STEPPER.OTHER_PROGRAMS_BLURB' | translate}}</div>
            
        <div class="pt-5 program-grid">
            <div class="row g-4">
                <div class="col-lg-6" *ngFor="let op of otherOptions; let i = index">
                    <div class="card">
                        <div class="card-header d-flex">
                            <img [class]="op.code === 'TSA' ? 'TSA-pre':'global-entry'" src="{{op.card.imageSrc}}" alt="{{op.card.imageAlt | translate}}">
                            <div class="program-price-container ms-auto">
                                <h3 class="program-price program-price-air"><b>${{op.card.headerPrice.cost}}</b></h3>
                                <span style="display: block;" *ngFor="let costInfo of op.card.headerPrice.costInfo; let i = index">{{ costInfo | translate}}</span>
                            </div>
                        </div>
            
                        <div class="card-body d-flex flex-column">
                        <p class="h3" [innerHTML]="op.card.title | translate"></p>
            
                        <div>
                            @for (description of op.card.description; track description) {
                                <p [innerHTML]="description | translate"></p>
                            }
                            
                            @if (op.card.includesPreCheck === 'yes')  {
                                <p><i><span [innerHTML]="'IMAGE_ALT.DOESINCLUDE_TSA_PRECHECK' | translate"></span></i></p>
                            }
                            @else if (op.card.includesPreCheck === 'maybe')  {
                                <p><i>{{'PROGRAM_SELECTION.SELECT_A_PROGRAM.MAY_INCLUDE'| translate}} <span [innerHTML]="'DASHBOARD.TSA_PRECHECK' | translate"></span></i></p>
                            }
                        </div>
            
                        <div class="mt-auto">
                            <a class="btn btn-primary" tabindex="0" (click)="logIn(op.code);" (keyup.enter)="logIn(op.code);"
                            target="_blank" rel="noopener noreferrer">{{'HOME.APPLY_NOW' | translate}}</a>
                            <a href="" class="learn-more ps-2" data-bs-dismiss="modal" [routerLink]="['programs-info']" [queryParams]="{code: op.code}" translate>HOME.ABOUT.LEARN_MORE</a>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

